module.exports = __webpack_public_path__ + "img/dummy6.722c703.jpg";